module.exports = __webpack_public_path__ + "img/selected3-min.d068914a.png";